import type { ReactNode } from "react";
import clsx from "clsx";

type PageActionBarAlign = "start" | "center" | "end" | "between";

type PageActionBarProps = {
  children: ReactNode;
  className?: string;
  align?: PageActionBarAlign;
  wrap?: boolean;
  mobileStack?: boolean;
};

const justifyClassName: Record<PageActionBarAlign, string> = {
  start: "sm:justify-start",
  center: "sm:justify-center",
  end: "sm:justify-end",
  between: "sm:justify-between",
};

const PageActionBar = ({
  children,
  className,
  align = "end",
  wrap = true,
  mobileStack = true,
}: PageActionBarProps) => (
  <div
    className={clsx(
      "flex gap-3",
      mobileStack ? "flex-col sm:flex-row" : "flex-row",
      wrap && "sm:flex-wrap",
      justifyClassName[align],
      className,
    )}
  >
    {children}
  </div>
);

export default PageActionBar;
